import { ContainerStatusEnum } from "../enum/ContainerStatusEnum";
import { ContainerStatusShortCodeEnum } from "../enum/ContainerStatusShortCodeEnum";
import { ContainerDisplayStatus } from "../model/ContainerDisplayStatus";


const COLUMN_UNKNOWN_STATUS = 'Unknown';
export const ContainerStatusColumnConfig = {
    content: (containerDisplayStatus: ContainerDisplayStatus) => {
        if (!containerDisplayStatus) {
            return COLUMN_UNKNOWN_STATUS;
        }
        if (containerDisplayStatus.transitStatus) {
            let backgroundColor = '#fffff';
            if (containerDisplayStatus.transitStatus.code === ContainerStatusShortCodeEnum.Unpack || containerDisplayStatus.transitStatus.code === ContainerStatusShortCodeEnum.Pack) {
                backgroundColor = '#ffb606';
            }
            else if (containerDisplayStatus.transitStatus.code === ContainerStatusShortCodeEnum.ReadyForPickup) {
                backgroundColor = '#e67e22';
            }
            return `<span class="status vertical-center" style="background-color: ${backgroundColor}">${containerDisplayStatus.transitStatus.description}</span>`;
        }

        if (containerDisplayStatus.portStatus) {
            if (containerDisplayStatus.portStatus.status === COLUMN_UNKNOWN_STATUS) {
                return COLUMN_UNKNOWN_STATUS;
            }

            if (containerDisplayStatus.portStatus.isHeld) {
                return `<span class="status vertical-center" style="background-color:#e43321">${containerDisplayStatus.portStatus.status}</span>`;
            }
            return `<span class="status vertical-center" style="background-color:#62cb31">${containerDisplayStatus.portStatus.status}</span>`;
        }

        return COLUMN_UNKNOWN_STATUS;
    },
    toolTip: (containerDisplayStatus: ContainerDisplayStatus, jobDirection: string) => {
      if (!containerDisplayStatus) {
          return;
      }
      if (containerDisplayStatus.transitStatus) {
          return containerDisplayStatus.transitStatus.description;
      }
      if (!containerDisplayStatus.portStatus) {
          return;
      }
      if (!jobDirection) {
        return;
      }
      const portStatus = containerDisplayStatus.portStatus;
      const inbound = jobDirection.toLowerCase().includes("inbound");
        const success = "bi bi-check-circle-fill green-extreme";
        const failed = "bi bi-question-circle-fill";
        if (inbound) {
            return `<table class="table">
            <tr><td>Active</td><td><i class="${portStatus.active ? success : failed}"></i></td></tr>
            <tr><td>Vessel Arrival</td><td><i class="${portStatus.vesselArrival ? success : failed}"></i></td></tr>
            <tr><td>Customs Release</td><td><i class="${portStatus.customsRelease ? success : failed}"></i></td></tr>
            <tr><td>LOP Release</td><td><i class="${portStatus.lopRelease ? success : failed}"></i></td></tr>
            <tr><td>MPI Release</td><td><i class="${portStatus.mpiRelease ? success : failed}"></i></td></tr>
            <tr><td>Discharged</td><td><i class="${portStatus.discharged ? success : failed}"></i></td></tr>
            <tr><td>Available</td><td><i class="${portStatus.available ? success : failed}"></i></td></tr>
            <tr><td>Cleared</td><td><i class="${portStatus.cleared ? success : failed}"></i></td></tr>
            <tr><td>Gate Out</td><td><i class="${portStatus.gateOut ? success : failed}"></i></td></tr>
            </table>
            `;
        }
        return `<table class="table">
            <tr><td>Active</td><td><i class="${portStatus.active ? success : failed}"></i></td></tr>
            <tr><td>Vessel Arrival</td><td><i class="${portStatus.vesselArrival ? success : failed}"></i></td></tr>
            <tr><td>Export Cleared</td><td><i class="${portStatus.exportCleared ? success : failed}"></i></td></tr>
            <tr><td>Gate In</td><td><i class="${portStatus.gateIn ? success : failed}"></i></td></tr>
            <tr><td>Load</td><td><i class="${portStatus.load ? success : failed}"></i></td></tr>
            <tr><td>Vessel Departure</td><td><i class="${portStatus.vesselDeparture ? success : failed}"></i></td></tr>
            </table>
            `;
    },
    shortCodes: (containerDisplayStatus: ContainerDisplayStatus) => {
        let shortCode = COLUMN_UNKNOWN_STATUS;
        let status = COLUMN_UNKNOWN_STATUS;

        if (containerDisplayStatus.transitStatus) {
            shortCode = containerDisplayStatus.transitStatus.code;
        } else if (containerDisplayStatus.portStatus) {
            status = containerDisplayStatus.portStatus.status;

            if (status === ContainerStatusEnum.Inbound) {
                shortCode = ContainerStatusShortCodeEnum.Pending;
            } else if (status === ContainerStatusEnum.Pending) {
                shortCode = ContainerStatusShortCodeEnum.Inbound;
            } else if (status === ContainerStatusEnum.Arrived) {
                shortCode = ContainerStatusShortCodeEnum.Arrived;
            } else if (status === ContainerStatusEnum.Wharf) {
                shortCode = ContainerStatusShortCodeEnum.ShipAtWharf;
            } else if (status === ContainerStatusEnum.Available) {
                shortCode = ContainerStatusShortCodeEnum.Available;
            } else if (status === ContainerStatusEnum.GateOut) {
                shortCode = ContainerStatusShortCodeEnum.GateOut;
            } else if (status === ContainerStatusEnum.FullInTransit) {
                shortCode = ContainerStatusShortCodeEnum.FullInTransit;
            } else if (status === ContainerStatusEnum.FullInTransitHub) {
                shortCode = ContainerStatusShortCodeEnum.FullInTransitHub;
            } else if (status === ContainerStatusEnum.FullInHub) {
                shortCode = ContainerStatusShortCodeEnum.FullInHub;
            } else if (status === ContainerStatusEnum.Unpack) {
                shortCode = ContainerStatusShortCodeEnum.Unpack;
            } else if (status === ContainerStatusEnum.ReadyForPickup) {
                shortCode = ContainerStatusShortCodeEnum.ReadyForPickup;
            } else if (status === ContainerStatusEnum.MTInTransit) {
                shortCode = ContainerStatusShortCodeEnum.MTInTransit;
            } else if (status === ContainerStatusEnum.MTInTransitHub) {
                shortCode = ContainerStatusShortCodeEnum.MTInTransitHub;
            } else if (status === ContainerStatusEnum.MTInHub) {
                shortCode = ContainerStatusShortCodeEnum.MTInHub;
            } else if (status === ContainerStatusEnum.Dehired) {
                shortCode = ContainerStatusShortCodeEnum.Dehired;
            } else if (status === ContainerStatusEnum.Pack) {
                shortCode = ContainerStatusShortCodeEnum.Pack;
            } else if (status === ContainerStatusEnum.Active) {
                shortCode = ContainerStatusShortCodeEnum.Active;
            } else if (status === ContainerStatusEnum.ShipAtWharf) {
                shortCode = ContainerStatusShortCodeEnum.ShipAtWharf;
            } else if (status === ContainerStatusEnum.OnVessel) {
                shortCode = ContainerStatusShortCodeEnum.OnVessel;
            } else if (status === ContainerStatusEnum.Departed) {
                shortCode = ContainerStatusShortCodeEnum.Departed;
            } else if (status === ContainerStatusEnum.Missed) {
                shortCode = ContainerStatusShortCodeEnum.Missed;
            } else if (status === ContainerStatusEnum.Discharged) {
                shortCode = ContainerStatusShortCodeEnum.Discharged;
            } else if (status === ContainerStatusEnum.WaitingRail) {
                shortCode = ContainerStatusShortCodeEnum.WaitingRail;
            } else if (status === ContainerStatusEnum.Inland) {
                shortCode = ContainerStatusShortCodeEnum.Inland;
            } else if (status === ContainerStatusEnum.OnRail) {
                shortCode = ContainerStatusShortCodeEnum.OnRail;
            }
        }
        return shortCode;
    },
}
